// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name, other, w = 22, h = 22) =>
  other ? (
    <img
      alt="navIcon"
      src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.${other}`}
      style={{ width: w, height: h }}
    />
  ) : (
    <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  );

const Masters = [
  {
    title: 'Category',
    path: '/dashboard/masters/Category',
    icon: icon('user'),
    ShortName: 'User_Master',
  },
  {
    title: 'Sub Category',
    path: '/dashboard/masters/SubCategory',
    icon: icon('user'),
    ShortName: 'User_Master',
  },
   {
    title: 'Brand',
    path: '/dashboard/masters/Brand',
    icon: icon('user'),
    ShortName: 'User_Master',
  },
  {
    title: 'Products',
    path: '/dashboard/masters/Products',
    icon: icon('user'),
    ShortName: 'User_Master',
  },
  {
    title: 'Customer',
    path: '/dashboard/masters/Customer',
    icon: icon('user'),
    ShortName: 'User_Master',
  },
  {
    title: 'PinCode',
    path: '/dashboard/masters/PinCode',
    icon: icon('user'),
    ShortName: 'User_Master',
  },
  {
    title: 'Discount',
    path: '/dashboard/masters/Discount',
    icon: icon('user'),
    ShortName: 'User_Master',
  }
];

export default Masters;
